import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { workshopService, Workshop } from "../services/firebase";
import "./FeaturedWorkshops.css";
import PrimaryButton from "./PrimaryButton";
import WorkshopCard from "./WorkshopCard";

// Sample workshop data for demonstration
const sampleWorkshops = [
  {
    id: "1",
    title: "סדנת לחמי מחמצת",
    location: "ראשון לציון",
    imageUrl: "/images/sourdough-workshop.jpg",
  },
  {
    id: "2",
    title: "סדנת בגטים וג'בטות",
    location: "חיפה",
    imageUrl: "/images/baguettes-workshop.jpg",
  },
  {
    id: "3",
    title: "סדנת פיצות ובצקים",
    location: "נתניה",
    imageUrl: "/images/pizza-workshop.jpg",
  },
];

const FeaturedWorkshops: React.FC = () => {
  const { t } = useTranslation();
  const [featuredWorkshops, setFeaturedWorkshops] = useState<Workshop[]>([]);
  const [loading, setLoading] = useState(true);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFeaturedWorkshops = async () => {
      try {
        const allWorkshops = await workshopService.getAll();
        // Take only the first 3 workshops (which are the newest due to desc order)
        const newestThreeWorkshops = allWorkshops.slice(0, 3);
        setFeaturedWorkshops(newestThreeWorkshops);
      } catch (error) {
                // Fallback to sample data if API fails
        setFeaturedWorkshops(sampleWorkshops.slice(0, 3) as any);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedWorkshops();
  }, []);

  return (
    <section className="workshops-section" ref={ref}>
      <p className="section-title">{t("workshopsTitle")}</p>
      <p className="section-description-bolt">
        {t("workshopsDescriptionBolt")}
      </p>
      <p className="section-description">{t("workshopsDescription")}</p>

      <div className="workshops-container">
        <div className="workshops-carousel">
          {loading ? (
            <div className="loading-container">{t("loadingWorkshops")}</div>
          ) : featuredWorkshops.length > 0 ? (
            featuredWorkshops.map((workshop) => (
              <WorkshopCard
                key={workshop.id}
                workshop={workshop}
                inView={inView}
              />
            ))
          ) : (
            <div className="empty-state">{t("noWorkshopsAvailable")}</div>
          )}
        </div>
      </div>
      <div className="all-workshops-button">
        <PrimaryButton onClick={() => navigate(`/workshops`)}>
          {t("allWorkshops")}
        </PrimaryButton>
      </div>
    </section>
  );
};

export default FeaturedWorkshops;
